export default "CEE agricoles & bâtiments d'exploitation | Solution Éco France";
